import { render, staticRenderFns } from "./index.vue?vue&type=template&id=9a451cbe&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=9a451cbe&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a451cbe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\chenwllCode\\cunxian\\web-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9a451cbe')) {
      api.createRecord('9a451cbe', component.options)
    } else {
      api.reload('9a451cbe', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=9a451cbe&scoped=true", function () {
      api.rerender('9a451cbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/distribution/index.vue"
export default component.exports